import React, { useEffect, useState, useRef, useMemo } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import { Eye } from "lucide-react";
import DetailsView from "./DetailsView";
import "react-datepicker/dist/react-datepicker.css";
import {
  getAllPosition,
  updateTargetAndStoploss,
  getUserName,
} from "../../../../Service/admin.service";
import { fDateTimeSuffix } from "../../../../Utils/Date_formet";
import "react-datepicker/dist/react-datepicker.css";
import { TRADE_EXECUTE } from "../../../../Service/user.service";
import toast from "react-hot-toast";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable1";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { SET_THEME_DETAILS } from "../../../../Service/auth.service";
import { Get_All_Service_for_Client } from "../../../../ReduxStore/Slice/Common/commoSlice";
import { useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import { usePrices } from "../../../../context/PriceContext";

const Tradinghistory = (token) => {
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const prices = usePrices();


  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [strategy, setStrategy] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [rowData, setRowData] = useState("");
  const [tradeHistoryData, setTradeHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [editableRows, setEditableRows] = useState({});
  const [tradeUpdates, setTradeUpdates] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [quantityM, setQuantity] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [btnstatus, setBtnstatus] = useState("");
  const [orderType, setOrderType] = useState("");
  const [allStrategy, setAllStrategy] = useState([]);
  const [entryType, setEntryType] = useState("");
  const [SelectedUserName, setSelectedUserName] = useState("ADMIN");
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [AllUsername, setAllUSerName] = useState([]);
  const [tradeViewType, setTradeViewType] = useState("USD");


  const permissions = JSON.parse(localStorage.getItem("permission"));


  const hasTradeBroker2or0 = tradeHistoryData.some(
    t => t.userInfo?.broker === "2" || t.userInfo?.broker === "0"
  );
  const hasPermissionBroker2 = permissions?.broker_id?.some(
    b => String(b.id) === "2"
  );


  const showLot =
    permissions?.trade_History_DeltaExchange === 1 ||
    (hasPermissionBroker2 && hasTradeBroker2or0);




  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newLimit, page) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };

  // Debounce search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    getCompanydata();
    GetAllStrategy();
    GetUSerName();
  }, []);

  const GetUSerName = async () => {
    const GetUserName = await getUserName({});
    if (GetUserName.status) {
      setAllUSerName(GetUserName.data);
    } else {
      setAllUSerName([]);
    }
  };

  const GetAllStrategy = async () => {
    try {
      dispatch(
        Get_All_Service_for_Client({
          req: {},
          token: user_details.token,
        })
      )
        .unwrap()
        .then((response) => {
          if (response.status) {
            setAllStrategy(response.data);
          }
        });
    } catch (error) { }
  };

  useEffect(() => {
    fetchTradeHistory();
  }, [
    fromDate,
    toDate,
    refresh,
    strategy,
    orderType,
    btnstatus,
    entryType,
    limit,
    currentPage,
    SelectedUserName,
    tradeViewType,
    debouncedSearchTerm,
  ]);

  // Calculate P&L function (reusable)
  const calculatePnL = (trade, livePrice) => {
    const permissions = JSON.parse(localStorage.getItem("permission"));

    const entryPrice = parseFloat(trade.entryPrice);
    const exitPrice = parseFloat(trade.exitPrice);
    const qty = quantityM && quantityM > 0 ? quantityM : trade.quantity;
    const isOpen = trade.orderid?.length === 1;

    if (!entryPrice || qty <= 0) return 0;

    let pnl = 0;
    if (isOpen && livePrice) {
      pnl =
        trade.side === "BUY"
          ? (livePrice - entryPrice) * qty
          : (entryPrice - livePrice) * qty;
    } else if (!isOpen && exitPrice) {
      pnl =
        trade.side === "BUY"
          ? (exitPrice - entryPrice) * qty
          : (entryPrice - exitPrice) * qty;
    }

    if (permissions?.trade_History_DeltaExchange === 1 || (hasPermissionBroker2 && hasTradeBroker2or0)) {
      if (trade.symbol === "BTCUSD") {
        pnl = pnl / 1000;
      } else if (trade.symbol === "ETHUSD") {
        pnl = pnl / 100;
      }
      else if (trade.symbol === "DOGEUSD") {
        pnl = pnl * 100;
      }
      else if (trade.symbol === "PAXGUSD") {
        pnl = pnl / 1000;
      }
    }

    return pnl;
  };

  const { filteredTradeData, totalPnl, unrealizedPnl } = useMemo(() => {
    let filtered = tradeHistoryData.filter((trade) => {
      const symbol = trade.symbol?.toUpperCase() || "";

      // 🔥 USD Trades only
      if (tradeViewType === "USD") {
        return symbol.endsWith("USD") || symbol.endsWith("USDT");
      }

      // 🔥 BTC Trades only
      if (tradeViewType === "INR") {
        return symbol.endsWith("INR") || symbol.includes("INR");
      }

      // 🔹 ALL Trades
      const matchStrategy = strategy ? trade.strategy === strategy : true;
      // const matchSearch =
      //   symbol.includes(debouncedSearchTerm.toUpperCase()) ||
      //   trade.strategy?.toLowerCase().includes(debouncedSearchTerm.toLowerCase());

      return matchStrategy;
    });

    let calculatedTotalPnl = 0;
    let calculatedUnrealizedPnl = 0;

    filtered.forEach((trade) => {
      const livePrice = prices?.[trade.symbol]?.spot_price;
      const pnl = calculatePnL(trade, livePrice);

      if (trade.orderid?.length === 2) {
        calculatedTotalPnl += pnl;
      } else if (trade.orderid?.length === 1) {
        calculatedUnrealizedPnl += pnl;
      }
    });

    return {
      filteredTradeData: filtered,
      totalPnl: calculatedTotalPnl,
      unrealizedPnl: calculatedUnrealizedPnl,
    };
  }, [
    tradeHistoryData,
    debouncedSearchTerm,
    strategy,
    quantityM,
    prices,
    tradeViewType,
  ]);



  const getCompanydata = async () => {
    try {
      const res = await SET_THEME_DETAILS();
      if (res.status) {
        setBtnstatus(res.data[0]?.pnl_position);
      }
    } catch (error) { }
  };

  const roundSmart = (value) => {
    if (isNaN(value)) return null;
    value = Number(value);

    let digits;
    if (Math.abs(value) >= 1000) {
      digits = 2;
    } else if (Math.abs(value) >= 1) {
      digits = 2;
    } else if (Math.abs(value) >= 0.01) {
      digits = 4;
    } else {
      digits = 6;
    }

    return Number(value.toFixed(digits));
  };

  const fetchTradeHistory = async () => {
    if (btnstatus == "") {
      return;
    }
    setLoading(true);
    try {
      const response = await getAllPosition({
        fromDate: fromDate,
        toDate: toDate,
        strategy: strategy,
        orderType: orderType,
        entryType: entryType,
        UserName: SelectedUserName,
        page: currentPage,
        limit: limit,
        currencyType: tradeViewType,
        searchSymbol: debouncedSearchTerm,
      });


      console.log("Trade History Response:", response);
      if (response?.status) {
        let allData = response.data || [];

        setTotalRows(response?.pagination?.totalRecords);

        setTradeHistoryData(allData);
      } else {
        setTradeHistoryData([]);
      }
    } catch (err) {
      setTradeHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const getFieldValue = (row, fieldName) => {
    return tradeUpdates[row._id]?.[fieldName] || row[fieldName] || "";
  };

  const getInputClassName = (row, fieldName) => {
    const errorKey = `${row._id}-${fieldName}`;
    return `form-control form-control-sm ${validationErrors[errorKey] ? "is-invalid" : ""
      }`;
  };

  const handleOnChange = (row, e) => {
    const { name, value } = e.target;
    if (!row._id) return;

    if (value < 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Negative values are not allowed!",
      });
      return;
    }

    setTradeUpdates((prev) => ({
      ...prev,
      [row._id]: { ...prev[row._id], [name]: value },
    }));
  };

  const handleUpdateRow = async (row) => {
    try {
      const target = parseFloat(tradeUpdates[row._id]?.target);
      const stoploss = parseFloat(tradeUpdates[row._id]?.stoploss);
      const entryPrice = parseFloat(row.entryPrice);

      if (!target && !stoploss) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please fill at least Target or Stoploss!",
        });
        return;
      }

      // 🔥 BUY VALIDATION
      if (row.side === "BUY") {
        if (target && target <= entryPrice) {
          Swal.fire({
            icon: "error",
            title: "Invalid Target",
            text: "BUY Target must be greater than Entry Price",
          });
          return;
        }

        if (stoploss && stoploss >= entryPrice) {
          Swal.fire({
            icon: "error",
            title: "Invalid Stoploss",
            text: "BUY Stoploss must be less than Entry Price",
          });
          return;
        }
      }

      if (row.side === "SELL") {
        if (target && target >= entryPrice) {
          Swal.fire({
            icon: "error",
            title: "Invalid Target",
            text: "SELL Target must be less than Entry Price",
          });
          return;
        }

        if (stoploss && stoploss <= entryPrice) {
          Swal.fire({
            icon: "error",
            title: "Invalid Stoploss",
            text: "SELL Stoploss must be greater than Entry Price",
          });
          return;
        }
      }

      const payload = {
        tradeId: row._id,
        target,
        stoploss,
      };

      const response = await updateTargetAndStoploss(payload);

      if (response?.status) {
        toast.success("Target & Stoploss updated successfully ");
        fetchTradeHistory();
        setEditableRows((prev) => ({ ...prev, [row._id]: false }));
      } else {
        toast.error(response?.message || "Update failed ");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong ❌");
    }
  };


  const refresbtn = () => {
    setStrategy("");
    setFromDate("");
    setToDate("");
    setOrderType(0);
    setEntryType("");
    setSearchTerm("");
    setSelectedUserName("ADMIN");
  };


  const handleSquareOff = async (row) => {
    if (row.extstatus !== "ACTIVE") return;

    let price = prices?.[row.symbol]?.spot_price;

    if (!price) {
      const { value: enteredPrice } = await Swal.fire({
        title: `Enter price for ${row.symbol}`,
        input: "number",
        inputPlaceholder: "Enter price",
        showCancelButton: true,
        confirmButtonText: "Submit",
      });

      if (!enteredPrice) {
        toast.error("Price is required to square off trade");
        return;
      }

      price = enteredPrice;
    }



    try {
      const data = `symbol:${row.symbol}|ordertype:${row.side === "BUY" ? "SELL" : "BUY"
        }|quantity:100|price:${price}|strategy:${row?.strategy
        }|key:${row.key}|category:${row.category
        }|signalType:PANEL_SQUAREOFF|tradeid:${row._id}`;

      const response = await TRADE_EXECUTE(data);

      if (response.status) {
        toast.success(response.message);
        fetchTradeHistory();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error in square off:", error);
      toast.error("Failed to square off trade");
    }
  };

  const handleChange = (date) => {
    const formatted = format(date, "yyyy-MM-dd");
    return formatted;
  };



  const columns = [
    {
      name: "No",
      selector: (row, index) => (currentPage - 1) * limit + index + 1,
      sortable: false,
      width: "70px",
    },

    {
      name: "Signals Entry Time",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: "Signals Exit Time",
      selector: (row) => row.exitTime,
      cell: (row) => <>{row.exitTime ? fDateTimeSuffix(row.exitTime) : "-"}</>,
      sortable: true,
      width: "170px",
    },
    {
      name: "Symbol",
      selector: (row) => row.symbol,
      sortable: true,
      width: "120px",
    },
    {
      name: "Entry Type",
      selector: (row) => row.side,
      cell: (row) =>
        row?.side === "BUY" ? (
          <span className="badge bg-success" style={{ fontSize: "0.9rem" }}>
            BUY ENTRY
          </span>
        ) : (
          <span className="badge bg-danger" style={{ fontSize: "0.9rem" }}>
            SELL ENTRY
          </span>
        ),
      sortable: true,
      width: "140px",
    },
    {
      name: (permissions?.trade_History_DeltaExchange === 1 || (hasPermissionBroker2 && (hasTradeBroker2or0))) ? "Lot" : "Quantity",
      selector: (row) => (row.quantity !== null ? quantityM : "-"),
      sortable: true,
      width: "115px",
    },
    {
      name: "Entry Price",
      selector: (row) =>
        row.entryPrice !== null ? parseFloat(row.entryPrice) : "-",
      sortable: true,
      width: "120px",
      cell: (row) =>
        row.entryPrice !== null ? roundSmart(row.entryPrice) : "-",
    },

    {
      name: "Exit / Live Price",
      selector: (row) => {
        const isOpen = row.statusType === "OPEN";

        const price = isOpen
          ? prices[row.symbol?.toUpperCase()?.trim()]?.spot_price
          : row.exitPrice;

        return price;
      },
      cell: (row) => {
        const isOpen = row.statusType === "OPEN";

        const price = isOpen
          ? prices[row.symbol?.toUpperCase()?.trim()]?.spot_price
          : row.exitPrice;

        // 🔴 If price null → show input
        if (price === undefined || price === null) {
          return (
            <input
              type="number"
              className="form-control form-control-sm"
              placeholder="Enter Price"
              onChange={(e) => {
                const value = e.target.value;

                setTradeUpdates((prev) => ({
                  ...prev,
                  [row._id]: {
                    ...prev[row._id],
                    manualExitPrice: value,
                  },
                }));
              }}
              style={{ width: "120px" }}
            />
          );
        }

        // 🟢 If price available → show value
        return roundSmart(price);
      },
      sortable: true,
      width: "160px",
    },

    {
      name: "P/L",
      selector: (row) => {
        const livePrice = prices?.[row.symbol]?.spot_price;
        return roundSmart(calculatePnL(row, livePrice));
      },
      cell: (row) => {
        const livePrice = prices?.[row.symbol]?.spot_price;
        const pnl = calculatePnL(row, livePrice);

        if (pnl === 0 && !parseFloat(row.entryPrice))
          return <span style={{ color: "gray" }}>-</span>;

        const pnlColor = pnl >= 0 ? "green" : "red";
        return <span style={{ color: pnlColor }}>{roundSmart(pnl)}</span>;
      },
      sortable: true,
      width: "100px",
    },
    {
      name: "Strategy",
      selector: (row) => row.strategy,
      sortable: true,
      width: "160px",
    },
    {
      name: "User Name",
      selector: (row) =>
        row.userInfo?.UserName ? row.userInfo?.UserName : "ADMIN",
      sortable: true,
      width: "150px",
      cell: (row) => <>{row.userInfo?.UserName}</>,
    },
    {
      name: "platform",
      selector: (row) => (row.platform ? row.platform : "PANEL"),
      sortable: true,
      width: "150px",
      cell: (row) => <>{row.platform}</>,
    },
    {
      name: "Target",
      selector: (row) => row.target,
      cell: (row) => (
        <input
          type="number"
          name="target"
          value={getFieldValue(row, "target") || ""}
          onChange={(e) => handleOnChange(row, e)}
          className={getInputClassName(row, "target")}
          placeholder="Target"
          step="0.01"
          disabled={!editableRows[row._id]}
        />
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Stop Loss",
      selector: (row) => row.stoploss,
      cell: (row) => (
        <input
          type="number"
          name="stoploss"
          value={getFieldValue(row, "stoploss") || ""}
          onChange={(e) => handleOnChange(row, e)}
          className={getInputClassName(row, "stoploss")}
          placeholder="Stop Loss"
          step="0.01"
          disabled={!editableRows[row._id]}
        />
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Action",
      cell: (row) => {
        if (row.usertype == "ADMIN" && row.platform == "PANEL") {
          const isEditable = editableRows[row._id];

          return (
            <div className="d-flex gap-2">
              {isEditable ? (
                <>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => handleUpdateRow(row)}
                  >
                    Confirm
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() =>
                      setEditableRows((prev) => ({ ...prev, [row._id]: false }))
                    }
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() =>
                    setEditableRows((prev) => ({ ...prev, [row._id]: true }))
                  }
                  disabled={row.extstatus !== "ACTIVE"}
                >
                  {row.extstatus == "ACTIVE" ? "Edit" : "Close"}
                </button>
              )}
            </div>
          );
        }
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "160px",
    },

    {
      name: "Square Off",
      cell: (row) => (
        <>
          {row.usertype == "ADMIN" && row.platform == "PANEL" && row.subadmin_id === null && (
            <button
              className="btn btn-outline-danger btn-sm"
              disabled={row.extstatus !== "ACTIVE"}
              onClick={() => {
                Swal.fire({
                  title: "Are you sure?",
                  text: "You want to square off this trade!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes, square off it!",
                }).then((result) => {
                  if (result.isConfirmed) {
                    handleSquareOff(row);
                  }
                });
              }}
              style={{
                opacity: row.extstatus === "ACTIVE" ? 1 : 0.5,
                cursor: row.extstatus === "ACTIVE" ? "pointer" : "not-allowed",
                fontWeight: "bold",
                borderRadius: "4px",
                padding: "2px 10px",
                minWidth: "90px",
              }}
              title={
                row.extstatus !== "ACTIVE"
                  ? "Trade already closed"
                  : "Square Off this trade"
              }
            >
              {row.extstatus !== "ACTIVE" ? "Trade Closed" : "Square Off"}
            </button>
          )}
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "150px",
    },
    {
      name: "Details View",
      cell: (row) => (
        <Eye
          className="mx-2"
          onClick={() => {
            setRowData(row);
            setshowModal(true);
          }}
          style={{ cursor: "pointer" }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "120px",
    },
  ];

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = async () => {
    try {
      const response = await getAllPosition({
        fromDate,
        toDate,
        strategy,
        orderType,
        entryType,
        UserName: SelectedUserName,
        page: 1, // 🔹 Always fetch first page
        limit: totalRows, // 🔹 Fetch full data for export
        searchSymbol: debouncedSearchTerm,
        currencyType: tradeViewType,
      });

      if (!response.status || !response.data?.length) {
        alert("No data available for export");
        return;
      }

      const apiData = response.data;
      const fileName = "Trade_History";

      // 🔹 Match Excel headers with your visible table columns
      const headers = [
        { key: "createdAt", label: "Signal Entry Time" },
        { key: "exitTime", label: "Signal Exit Time" },
        { key: "symbol", label: "Symbol" },
        { key: "side", label: "Entry Type" },
        { key: "quantity", label: "Quantity" },
        { key: "entryPrice", label: "Entry Price" },
        { key: "exitPrice", label: "Exit / Live Price" },
        { key: "pnlSafe", label: "P/L" },
        { key: "strategy", label: "Strategy" },
        { key: "userInfo.UserName", label: "User Name" },
        { key: "platform", label: "Platform" },
        { key: "target", label: "Target" },
        { key: "stoploss", label: "Stop Loss" },
        { key: "extstatus", label: "Order Status" },
      ];

      // 🔹 Flatten nested fields like `userInfo.UserName`
      const formattedData = apiData.map((row, index) => {
        const formattedRow = { No: index + 1 };
        headers.forEach(({ key, label }) => {
          const keys = key.split(".");
          let value = row;
          keys.forEach((k) => {
            value = value ? value[k] : "";
          });

          // Format date fields
          if (label.toLowerCase().includes("time") && value) {
            value = new Date(value).toLocaleString();
          }

          // Handle side (BUY/SELL) visually
          if (key === "side") {
            value = value === "BUY" ? "BUY ENTRY" : "SELL ENTRY";
          }

          // Handle empty/null values
          formattedRow[label] = value ?? "-";
        });
        return formattedRow;
      });

      // 🔹 Add headers row (first row)
      const ws = XLSX.utils.json_to_sheet(formattedData, {
        header: ["No", ...headers.map((h) => h.label)],
        skipHeader: false,
      });

      // 🔹 Auto-adjust column widths
      const colWidths = ["No", ...headers.map((h) => h.label)].map((header) => {
        const maxContent = Math.max(
          header.length,
          ...formattedData.map((row) => String(row[header] || "").length)
        );
        return { width: maxContent + 5 };
      });
      ws["!cols"] = colWidths;

      // 🔹 Create and export workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Trade Data");
      XLSX.writeFile(wb, `${fileName}${fileExtension}`);
    } catch (error) {
      console.error("❌ Excel Export Error:", error);
    }
  };

  return (
    <Content
      Page_title="Trade History"
      button_status={false}
      button_status1={true}
    >
      <div className="col-lg-2 col-md-3 col-sm-6 col-6 ">
        <button
          style={{
            position: "absolute",
            right: "30px",
            top: "114px",
            width: "130px",
          }}
          onClick={() => exportToExcel()}
          type="button"
          className="btn btn-primary btn-sm float-lg-end export-btn "
          title="Export To Excel"
        >
          <i className="fa fa-download" aria-hidden="true"></i> Export Excel
        </button>
      </div>
      <div className="filter-row row gx-2 gy-2 align-items-end mb-3">
        {/* 🔍 Search */}
        <div className="col-lg-2 col-md-4 col-sm-6 col-6">
          <label className="form-label mb-1 fw-semibold">Search</label>
          <input
            type="text"
            placeholder="Search by Symbol"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control"
          />
        </div>

        {/* 👤 Username */}
        <div className="col-lg-2 col-md-3 col-sm-6 col-6">
          <label className="form-label mb-1 fw-semibold">User Name</label>
          <select
            value={SelectedUserName}
            onChange={(e) => setSelectedUserName(e.target.value)}
            className="form-control"
          >
            {/* <option value="">All</option> */}
            <option value="ADMIN">Admin</option>

            {AllUsername?.map((data, index) => (
              <option key={index} value={data.UserName}>
                {data.UserName}
              </option>
            ))}
          </select>
        </div>

        {/* 📅 From Date */}
        <div className="col-lg-2 col-md-3 col-sm-6 col-6">
          <label className="form-label mb-1 fw-semibold">From Date</label>
          <DatePicker
            selected={fromDate ? new Date(fromDate) : null}
            onChange={(date) => setFromDate(handleChange(date))}
            dateFormat="yyyy-MM-dd"
            placeholderText="From"
            className="form-control"
          />
        </div>

        {/* 📅 To Date */}
        <div className="col-lg-2 col-md-3 col-sm-6 col-6">
          <label className="form-label mb-1 fw-semibold">To Date</label>
          <DatePicker
            selected={toDate ? new Date(toDate) : null}
            onChange={(date) => setToDate(handleChange(date))}
            dateFormat="yyyy-MM-dd"
            placeholderText="To"
            className="form-control"
            minDate={fromDate ? new Date(fromDate) : null}
          />
        </div>

        {/* 📈 Strategy */}
        <div className="col-lg-1 col-md-3 col-sm-6 col-6">
          <label className="form-label mb-1 fw-semibold">Strategy</label>
          <select
            value={strategy}
            onChange={(e) => setStrategy(e.target.value)}
            className="form-control"
          >
            <option value="">All</option>
            {allStrategy?.map((strategyOption, index) => (
              <option key={index} value={strategyOption.strategy_name}>
                {strategyOption.strategy_name}
              </option>
            ))}
          </select>
        </div>

        {/* 🧾 Order Type */}
        <div className="col-lg-1 col-md-3 col-sm-6 col-6">
          <label className="form-label mb-1 fw-semibold">Order</label>
          <select
            className="form-control"
            value={orderType}
            onChange={(e) => setOrderType(e.target.value)}
          >
            <option value="">All </option>
            <option value="1">OPEN</option>
            <option value="2">CLOSED</option>
          </select>
        </div>

        {/* 🧭 Entry  */}
        <div className="col-lg-1 col-md-3 col-sm-6 col-6">
          <label className="form-label mb-1 fw-semibold">Entry </label>
          <select
            className="form-control"
            value={entryType}
            onChange={(e) => setEntryType(e.target.value)}
          >
            <option value="">All </option>
            <option value="BUY">Buy</option>
            <option value="SELL">Sell</option>
          </select>
        </div>

        {/* 🔢 Quantity */}
        <div className="col-lg-1 col-md-3 col-sm-6 col-6">
          <label className="form-label mb-1 fw-semibold">
            {permissions?.trade_History_DeltaExchange === 1
              ? "Lot"
              : "Quantity"}
          </label>

          <input
            type="number"
            className="form-control"
            value={quantityM}
            onChange={(e) => {
              const val = e.target.value;
              setQuantity(val === "" ? "" : Number(val));
            }}
          />
        </div>

        {/* 🔁 Refresh Button */}
        <div className="col-lg-1 col-md-3 col-sm-2 col-2 d-flex justify-content-end">
          <button
            className="btn btn-sm btn-primary mt-auto w-100"
            onClick={() => {
              setRefresh((prev) => !prev);
              refresbtn();
            }}
          >
            <i className="fa fa-refresh"></i>
          </button>
        </div>



        <div className="col-lg-3 col-md-4 col-sm-12 d-flex gap-2">
          {/* <button
            className={`btn btn-sm ${tradeViewType === "ALL" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setTradeViewType("ALL")}
          >
            All Trades
          </button> */}

          <button
            className={`btn btn-sm ${tradeViewType === "USD" ? "btn-success" : "btn-outline-success"}`}
            onClick={() => setTradeViewType("USD")}
          >
            USD Trades
          </button>
          {(permissions?.trade_History_DeltaExchange != 1) &&
            <button
              className={`btn btn-sm ${tradeViewType === "INR" ? "btn-warning" : "btn-outline-warning"}`}
              onClick={() => setTradeViewType("INR")}
            >
              INR Trades
            </button>
          }
        </div>



      </div>

      {btnstatus === "0" && (
        <div
          className=" alert alert-warning mt-3 d-flex flex-wrap justify-content-between justify-content-md-start align-items-center"
          style={{
            borderTop: "1px solid #ddd",
            paddingTop: "10px",
            marginBottom: "10px",
            borderRadius: "8px",
            padding: "10px 15px",
          }}
        >
          {/* Realized P&L */}
          <div className="realized-text ">
            <h6 className="mb-1 fw-semibold">Realized P&L</h6>
            <span
              className="ms-1"
              style={{
                color: Number(totalPnl) >= 0 ? "green" : "red",
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              :  {Number(roundSmart(totalPnl || 0))}
            </span>
          </div>

          {/* Unrealized P&L */}
          <div className="realized-text ms-3">
            <h6 className="mb-1 fw-semibold fs-6">UnRealized P&L</h6>
            <span
              className="ms-1"
              style={{
                color: Number(unrealizedPnl) >= 0 ? "green" : "red",
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              :{Number(roundSmart(unrealizedPnl || 0))}
            </span>
          </div>
        </div>
      )}

      <div className="">
        <Table
          columns={columns}
          data={filteredTradeData}
          waterMark={true}
          totalRows={totalRows}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handlePerRowsChange}
          limit={limit}
        />

        {btnstatus == "1" && (
          <div className="mt-3 d-flex justify-content-end realized-text alert alert-warning">
            <h6>
              Realized P&L:{" "}
              <span style={{ color: totalPnl >= 0 ? "green" : "red" }}>
                {Number(roundSmart(totalPnl || 0))}
              </span>
            </h6>
            <h6 className="ms-4">
              UnRealized P&L:{" "}
              <span
                style={{
                  color: Number(unrealizedPnl) >= 0 ? "green" : "red",
                }}
              >
                {Number(roundSmart(unrealizedPnl || 0))}
              </span>
            </h6>
          </div>
        )}
      </div>

      <DetailsView
        showModal={showModal}
        setshowModal={() => setshowModal(false)}
        tradeHistoryData={rowData}
      />
    </Content>
  );
};

export default Tradinghistory;
